export default "__VITE_ASSET__Ccndu6ev__"